import React from "react";
import moment from "moment";

import { CardLayout, H2, PageSection, ExternalUpdateCard } from "components";

export const ExternalUpdates = (props) => {
  return (
    <PageSection column="true" borderTop="true">
      <H2
        children={
          props.primary &&
          props.primary.title &&
          props.primary.title[0] &&
          props.primary.title[0].text
        }
        mb={5}
        fontSize={[4, 5]}
      />
      <CardLayout w={1 / 1}>
        {props.items &&
          props.items
            .sort(function (a, b) {
              if (moment(a.date).utc() < moment(b.date).utc()) return 1;
              if (moment(a.date).utc() > moment(b.date).utc()) return -1;
              return 0;
            })
            .map((update, index) => (
              <ExternalUpdateCard key={"update" + index} {...update} />
            ))}
      </CardLayout>
    </PageSection>
  );
};



// WEBPACK FOOTER //
// ./src/slices/ExternalUpdates/ExternalUpdates.js